"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPRequest = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var HTTPRequest = (function () {
    function HTTPRequest() {
    }
    HTTPRequest.prototype.json = function (path, payload, method, headers) {
        if (method === void 0) { method = "GET"; }
        if (headers === void 0) { headers = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, requestInit, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        requestInit = { method: method };
                        if (payload) {
                            headers["Accept"] = "application/json";
                            headers["Content-Type"] = "application/json";
                            requestInit.body = JSON.stringify(payload);
                        }
                        requestInit.headers = headers;
                        return [4, fetch(path, requestInit)];
                    case 1:
                        response = _a.sent();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        utils_1.log.warn(e_1);
                        return [3, 3];
                    case 3:
                        if (response) {
                            try {
                                return [2, response.json()];
                            }
                            catch (e) {
                                utils_1.log.warn(e);
                            }
                        }
                        return [2];
                }
            });
        });
    };
    HTTPRequest = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], HTTPRequest);
    return HTTPRequest;
}());
exports.HTTPRequest = HTTPRequest;
//# sourceMappingURL=HTTPRequest.js.map